import { z } from 'zod';
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().optional(),
  VITE_SET_ASSET_COOKIE_SKIP: z.string().transform(value => value === 'TRUE').optional(),
  VITE_PROXY_API_URL: z.string().optional(),
  VITE_DEBUG_AUTO_SIGNIN_USERNAME: z.string().optional(),
  VITE_DEBUG_AUTO_SIGNIN_PASSWORD: z.string().optional(),
  VITE_ORY_KRATOS_URL: z.string().optional(),
  VITE_DATADOG_ENABLED: z.string().transform(value => value === 'TRUE').optional(),
  VITE_DATADOG_CLIENT_TOKEN: z.string().optional()
});
export const env = envSchema.parse(import.meta.env);